import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid, Button, CircularProgress,
} from '@material-ui/core';
import actions from 'shared/actions';
import styles from 'shared/styles';

export const testId = 'btn';

export function ResetPasswordButtonImpl({ password, onClick, canClick }) {
  const [clicked, setClicked] = React.useState(false);
  const btnText = clicked ? <CircularProgress color="white" size={24} /> : 'Reset Password';
  const disabled = !canClick || clicked;
  return (
    <>
      <Grid item xs={12}>
        <Button
          onClick={() => {
            setClicked(true);
            onClick(password);
          }}
          style={styles.submitButton}
          data-test={testId}
          disabled={disabled}
        >
          {btnText}
        </Button>
      </Grid>
    </>
  );
}

ResetPasswordButtonImpl.propTypes = {
  password: PropTypes.string.isRequired,
  canClick: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  onClick: actions.staging.onSubmitResetPassword,
};

export default connect(null, mapDispatchToProps)(ResetPasswordButtonImpl);
